var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPrevious(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8.7 15.1",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#94979A",
    d: "M7.5 0c.3 0 .6.1.8.3.5.5.5 1.2 0 1.7L2.8 7.5 8.3 13c.5.5.5 1.2 0 1.7s-1.2.5-1.7 0L.3 8.4c-.5-.5-.5-1.2 0-1.7L6.7.3c.2-.2.5-.3.8-.3z"
  })));
}

export default SvgIconPrevious;